import { RobotOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { Divider, Form, Input, Upload } from 'antd'
import { CSRF_TOKEN_KEY, IMAGE_UPLOAD_PATH } from 'common/constants'
import { getNs } from 'common/i18n-config'

import { Photo } from '../hooks/use-ai-suggestion'
import { AIFormContentWrapper } from '../styles'

const { Dragger } = Upload
const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

export const AIFormContent = ({
  assetName,
  setAssetName,
  onSubmit,
}: {
  assetName?: string
  setAssetName: (name: string) => void
  onSubmit: (photo?: Photo) => void
}) => {
  useNsReady()

  const headers: any = {
    'X-CSRF-Token': localStorage.getItem(CSRF_TOKEN_KEY),
  }

  return (
    <AIFormContentWrapper>
      <Form layout="vertical">
        <Form.Item label={t('enter_asset_name')}>
          <Input
            placeholder={t('enter_asset_name_placeholder')}
            maxLength={100}
            value={assetName}
            onChange={e => setAssetName(e.target.value)}
          />
        </Form.Item>
        <Divider plain>{t('or')}</Divider>
        <Form.Item label={t('upload_an_image')}>
          <Dragger
            withCredentials
            accept="image/*"
            action={IMAGE_UPLOAD_PATH}
            headers={headers}
            onChange={({ file }) => {
              onSubmit(file?.response?.data?.id)
            }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{ color: '#3b7de9', fontSize: 32 }} />
            </p>
            <p className="ant-upload-text">{t('upload_an_image_2')}</p>
          </Dragger>
        </Form.Item>
        <If condition={assetName}>
          <Form.Item>
            <Button type="button" block icon={<RobotOutlined />}>
              {t('run_ai_analysis')}
            </Button>
          </Form.Item>
        </If>
      </Form>
    </AIFormContentWrapper>
  )
}
